export default __webpack_public_path__ + "static/media/home.bb293278.png";